import { get, find } from 'lodash';
import { connect } from 'react-redux';

import ReturnsPageCountrySelector from 'components/ReturnsPageCountrySelector';
import * as actions from 'state/actions';
import { MODAL_TYPES } from 'state/constants';
import Settings from 'utils/Settings';

const mapStateToProps = (state, { options }) => {
  const isModalOpen = get(state, ['app', 'modal']) === MODAL_TYPES.RETURNS_PAGE;
  let defaultOption = find(options, ({ shopID }) => shopID === Settings.shopID);

  if (!defaultOption) {
    defaultOption = get(options, 0);
  }

  return {
    isModalOpen,
    defaultOption,
  };
};

const mapDispatchToProps = dispatch => ({
  openModal: () => dispatch(actions.openReturnsPageModal()),
  closeModal: () => dispatch(actions.closeModal()),
  onSubmit: shopID => dispatch(actions.submitReturnsPage(shopID)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ReturnsPageCountrySelector);
